export default {
  name: 'CColumns',
  components: {},
  props: {
    titleProp: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: ''
    },
    nomouse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentIndex: ''
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleMouseenter(index, item) {
      this.currentIndex = index;
      this.$emit('item', item);
    },
    handleMouseleave(item) {
      this.currentIndex = '';
      this.$emit('item', item);
    }
  }
};